import { CounterpartyType } from '@/constants/CounterpartyType';
import { Period } from "@/constants/DateTimeConstants";
import { TaxReportForm } from "@/constants/TaxReportForm";

export enum TaxObligationSortField {
    REPORT_FILING_DEADLINE = "REPORT_FILING_DEADLINE",
    YEAR = "YEAR",
    PERIOD = "PERIOD",
    AMOUNT = "AMOUNT",
    STATUS = "STATUS",
    PAYMENT_STATUS = "PAYMENT_STATUS",
    RISK = "RISK",
    ASSIGNEE = "ASSIGNEE",
    CREATED_AT = "CREATED_AT",
    UPDATED_AT = "UPDATED_AT"
}

export default class TaxObligationFilter {
    // Filters
    reportFilingDeadlineFrom: string | null = null;
    reportFilingDeadlineTo: string | null = null;
    isPaid: boolean | null = null;
    taxReportForm: TaxReportForm | null = null;
    state: string | null = null;
    customerId: number | null = null;
    customerType: CounterpartyType | null = null;
    createdById: number | null = null;
    lastModifiedById: number | null = null;
    year: number | null = null;
    period: Period | null = null;
    noSubmissionId = false;

    // Pagination
    pageNumber = 1; // Frontend pagination usually starts with 1, will subtract 1 manually if needed, wait backend expects 0-indexed page for Pageable.
    pageSize = 20;

    // Sorting
    sortBy: TaxObligationSortField = TaxObligationSortField.CREATED_AT;
    sortDirection: "ASC" | "DESC" = "DESC";
}
